import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';

const CancelButton = ({ onCancel }) => {
  const { t } = useTranslation();

  return (
    <Button icon={<RollbackOutlined />} onClick={onCancel}>
      {t('actions.cancel')}
    </Button>
  );
};

export default CancelButton;
